import { yieldToMain } from 'js/common/yield-to-main';
import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

async function trackMapEvent(
  category: string,
  action: string,
  label?: string,
  value?: string
) {
  await yieldToMain();

  trackStructuredEvent({
    category,
    property: 'map',
    action,
    label,
    value,
  });
}

export function open(category: string) {
  return trackMapEvent(category, 'open');
}

export function close(category: string, mapZoom: string) {
  return trackMapEvent(category, 'close', undefined, mapZoom);
}

export function pan(category: string, mapZoom: string) {
  return trackMapEvent(category, 'pan', undefined, mapZoom);
}

export function zoom(category: string, direction: string, mapZoom: string) {
  return trackMapEvent(category, 'zoom', direction, mapZoom);
}

export function callVenueEvent(category: string): void {
  trackStructuredEvent({
    category,
    property: 'call_venue_button',
    action: 'click',
  });
}

export function getDirectionsEvent(category: string): void {
  trackStructuredEvent({
    category,
    property: 'venue_direction_button',
    action: 'click',
  });
}
